import React, { useState } from 'react';
import {
    Button,
    IconButton,
    Typography,
    Box,
    Modal,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};

const CustomeNotificationImage = ({ open, onClose }) => {

    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="end" alignItems="center"
                    sx={{ p: '20px', pb: '0', borderBottom: 'none', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>

                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', pb: '26px' }} dividers>
                    <Box sx={{ textAlign: 'center' }}>
                        <Typography sx={{ fontSize: '17px', color: '#1A1F36', fontWeight: '700', lineHeight: '1.2' }}>Our Insights add-on now includes Smart Notifications</Typography>
                        <Typography sx={{ fontSize: '13px', color: '#373737', margin: ' 10px auto 20px', lineHeight: '1.4' }}>set custom criteria to monitor key metrics and get alerts via email, Slack, or directly in Insights when activity matches your rules.</Typography>
                        <div><img src="./assets/images/insights/notification/custome-notification-img.png" alt='custome-notification' className="img-fluid" /></div>
                    </Box>
                    <div>
                        <div className="fw-bold" style={{ fontSize: '14px', color: '#1A1F36' }}>Insights add-on also includes</div>
                        <ul className="m-8 list-style-inside" style={{ listStyle: 'inside' }}>
                            <li style={{ fontSize: '12px', color: '#373737' }}>Custom Hourly, Daily, Weekly and Monthly Smart Notifications</li>
                            <li style={{ fontSize: '12px', color: '#373737' }}>Core work, focus time and meetings analytics</li>
                            <li style={{ fontSize: '12px', color: '#373737' }}>Unusual Activity logging and investigation tools</li>
                            <li style={{ fontSize: '12px', color: '#373737' }}>Time fraud App/URL monitoring and alerting</li>
                        </ul>
                    </div>
                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: 'none', position: 'sticky', bottom: 0, display: 'flex', justifyContent: 'center', borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="contained" className='text-capitalize' color="primary" sx={{ backgroundColor: '#0076FE', p: '8px 24px', fontSize: '16px', fontWeight: '500', height: '40px', border: 'none', borderRadius: '100px' }}>
                        Add Add-ons
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default CustomeNotificationImage;
